import { Image as ImageMain } from './Image';
export function createImage({ Root, }) {
    const Image = ImageMain(Root);
    Image.displayName = 'Image';
    return Image;
}
